import * as actions from '../_actions/types';

export const initialNav = () => {
  if (window.innerWidth <= 800) {
    return { type: actions.INITIAL_NAV, smallWindow: true, navOpen: false }
  }
  return { type: actions.INITIAL_NAV, smallWindow: false, navOpen: true }
}

export const toggleNav = (open) => {
  return {
    type: actions.TOGGLE_NAV,
    payload: open,
  }
}

export const toggleNavResize = (navOpen, smallWindow) => {
  return { type: actions.TOGGLE_NAV_RESIZE, navOpen: navOpen, smallWindow: smallWindow }
}

export const createPdf = (html, name) => {
  return (dispatch) => {
    dispatch({
      type: actions.CREATE_PDF_FROM_HTML,
      html,
      name
    });

    const requestBody = JSON.stringify({ html });

    fetch('https://mozak-app.herokuapp.com/createpdf', {
      method: 'POST',
      mode: 'cors',
      body: requestBody
    })
      .then(response => response.blob())
      .then(blob => {
        dispatch({ type: actions.CREATE_PDF_FROM_HTML_SUCCESS });
        var url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch(error => {
        dispatch({ type: actions.CREATE_PDF_FROM_HTML_ERROR, error });
      });
  }
};



// WEBPACK FOOTER //
// ./src/common/common_actions.js